import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
 
import Navigation from '../Navigation';
import LandingPage from '../Landing';
import SignUpPage from '../SignUp';
import SignInPage from '../SignIn';
import PasswordForgetPage from '../PasswordForget';
import RegistrationPage from '../Registration';
import CompetitorRegPage from '../Registration/reg_competitor';
import MentorRegPage from '../Registration/reg_mentor';
import RegDonePage from '../Registration/reg_done';

import AccountPage from '../Account';
import AdminPage from '../Admin';

import DashboardPage from '../Landing/dashboard';
 
import * as ROUTES from '../../constants/routes';
import { withAuthentication } from '../Session';
import DashboardLayout from '../Homepage/DashboardLayout';
//import Homepage from '../Homepage/Homepage';
//import Announcements from '../Homepage/Announcements';
//import ResourceCenter from '../ResourceCenter'
// import Announcement from '../Announcement/Announcement'
 
const App = () => (
  <Router>
      <Switch>
          <Route path="/main" component={LargeLayout} />
          <Route path="/dash" component={DashboardLayout} />
          <Route path="/" component={LargeLayout} />
      </Switch>
  </Router>
);
 

const LargeLayout = () => (
    <div>
      <Navigation />
      <hr />
      
      <Route exact path={ROUTES.LANDING} component={LandingPage} />
      <Route exact path={ROUTES.DASHBOARD} component={DashboardPage} />

      <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
      <Route path={ROUTES.SIGN_IN} component={SignInPage} />

      <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage}/>
      <Route path={ROUTES.ACCOUNT} component={AccountPage} />
      <Route path={ROUTES.ADMIN} component={AdminPage} />

      <Route path={ROUTES.REG_HOME} component={RegistrationPage} />
      <Route path={ROUTES.REG_COMPETITOR} component={CompetitorRegPage} />
      <Route path={ROUTES.REG_MENTOR} component={MentorRegPage} />
      <Route path={ROUTES.REG_DONE} component={RegDonePage} />


  </div>
);


export default withAuthentication(App);